export const TERMS_AND_PP_ERROR_MESSAGE = "You must accept these terms to continue";
export const NO_BANK_ACCOUNTS_ERROR_MESSAGE = "You must link at least 1 bank account to continue";